import { catchError, map, Observable, of, share } from 'rxjs';
import { environment } from 'src/environments/environment';

import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';

@Injectable()
export class SvgService {
  private readonly _http: HttpClient | null = null;

  constructor(@Optional() private handler: HttpBackend) {
    if (this.handler) {
      this._http = new HttpClient(this.handler);
    }
  }

  loadIcon(name: string): Observable<SVGElement | null> {
    return this.loadSvg(name);
  }

  loadFlag(name: string): Observable<SVGElement | null> {
    return this.loadSvg(name, 'flags');
  }

  private loadSvg(name: string, type: string = 'icons'): Observable<SVGElement | null> {
    if (!this._http) return of(null);
    const url = this.svgUrl(name, type);

    return this._http.get(url, { responseType: 'text' }).pipe(
      map(svg => {
        const div = document.createElement('div');
        div.innerHTML = svg;
        return div.querySelector('svg') as SVGElement;
      }),
      catchError(() => of(null)),
      share()
    );
  }

  private svgUrl(name: string, type: string): string {
    return `${environment.baseHref}assets/images/${type}/${name}.svg`;
  }
}
